<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
        tooltip-placement="right"
        uib-tooltip="Cancel"
      />
    </a>

    <div class="action-icon">
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showForm"
      >
        <i
          v-tooltip.bottom.hover="$t('EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'EDIT'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <div class="action-icon">
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="onDelete"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="currentAddress.id"
      :object-name="currentAddress.incomingQueryStringName"
      object-type="Address"
    />

    <ConfirmationModal
      v-if="showPopOver"
      ref="modal"
      :title="$t('TITLE_DELETE')"
      :cancel-button-text="$t('CANCEL')"
      :confirm-action-text="$t('DELETE')"
      :show-header-close-button="false"
      @confirm="onConfirm"
      @close="onCancel"
    >
      {{ $t('DELETE_ADDRESS_MODAL_MESSAGE') }}
    </ConfirmationModal>
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction.vue';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal.vue';

export default {
  name: 'AddressActions',
  components: {
    ChangeLogObjectButtonAction,
    ConfirmationModal
  },
  props: {
    /** @type {() => Vue.PropOptions<ringba.data.AddressRecord>} */
    currentAddress: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showPopOver: false,
    popoverValue: false,
    placement: 'bottomleft'
  }),
  methods: {
    showModal() {
      this.showPopOver = true;
    },
    hideModal() {
      this.showPopOver = false;
    },
    onConfirm() {
      this.$emit('confirm-delete', this.currentAddress.id);
      this.hideModal();
    },
    onDelete() {
      this.showModal();
    },
    onCancel() {
      this.hideModal();
    },
    showForm() {
      if (!this.disabled) {
        this.$emit('edit', this.currentAddress.id);
      }
    },
    collapseActions() {
      this.$emit('collapse-actions', this.currentAddress.id);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss">
form.user {
  .multi-select-lg {
    width: 100%;
  }

  .v-select .vs__selected {
    height: 32px;
    padding: 8px 8px 7px 10px;
    border-bottom: 1px solid transparent;
  }
}

.popover.left > .arrow:after {
  border-left-color: var(--component-in-app-notifications__popover);
}
</style>